import { gql, useSuspenseQuery } from '@apollo/client';
import { useLocation } from 'react-use';

import { BasicAddressWithTimezoneFragment, IBasicAddressWithTimezone } from '../../utils/addresses';

const ADDRESS_FOR_VISIT_BOOKING_FLOW_QUERY = gql`
    query AddressForVisitBookingFlow($id: UUID!) {
        address(id: $id) {
            ...BasicAddressWithTimezoneFragment
        }
    }
    ${BasicAddressWithTimezoneFragment}
`;

type AddressForVisitBookingFlowQueryType = {
    address: IBasicAddressWithTimezone | null;
};

export const useAddressForVisitBookingFlow = (): IBasicAddressWithTimezone | null => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const addressId = params.get('addressId');
    const { data } = useSuspenseQuery<AddressForVisitBookingFlowQueryType>(
        ADDRESS_FOR_VISIT_BOOKING_FLOW_QUERY,
        {
            skip: !addressId,
            variables: { id: addressId },
        },
    );
    return data?.address ?? null;
};
